/** Клавіатура ручного вводу штрихкоду / артикулу (збірка, перевірка цін) */
export const TERMINAL_ALPHANUM_KEYBOARD_LAYOUT = {
  default: [
    '1 2 3 4 5 6 7 8 9 0',
    'Q W E R T Y U I O P',
    'A S D F G H J K L',
    'Z X C V B N M -',
    '{bksp}',
  ],
};

export const TERMINAL_ALPHANUM_KEYBOARD_DISPLAY = {
  '{bksp}': '⌫',
};
